import React from "react";
import Layout from "components/Layout";
import "styles/legal.css";

const DatenschutzPage = () => {
  return (
    <Layout>
      <section className="legal-page">
        <div className="legal-shell">
          <p className="legal-kicker">Datenschutz</p>
          <h1>Datenschutzerklärung</h1>

          <p className="legal-meta">
            Stand: Juli 2026. Diese Datenschutzerklärung gilt für
            dr-hoffmann-massage.de einschließlich der Buchungs-, Konto-,
            Zahlungs-, Empfehlungs-, QR-, Team- und Hotelbuchungsfunktionen.
          </p>

          <div className="legal-toc" aria-label="Inhalt">
            <a href="#verantwortlicher">Verantwortlicher</a>
            <a href="#buchung">Buchungen</a>
            <a href="#zahlungen">Zahlungen</a>
            <a href="#cookies">Cookies</a>
            <a href="#rechte">Rechte</a>
          </div>

          <h2 id="verantwortlicher">1. Verantwortlicher</h2>
          <p>
            MediConsult GmbH, Cremon 11, 20457 Hamburg, Deutschland,
            vertreten durch Geschäftsführer Andreas Metz.
          </p>
          <p>
            Telefon: <a href="tel:+4940457543">+49 (0)40 457543</a>
            <br />
            E-Mail:{" "}
            <a href="mailto:info@dr-hoffmann-massage.de">
              info@dr-hoffmann-massage.de
            </a>
          </p>

          <h2>2. Grundsätze</h2>
          <p>
            Wir verarbeiten personenbezogene Daten nur, soweit dies für den
            Betrieb der Website, die Kommunikation, die Konto- und
            Terminverwaltung, die Durchführung gebuchter Leistungen, Zahlungen,
            gesetzliche Pflichten oder berechtigte Interessen erforderlich ist.
            Rechtsgrundlagen sind insbesondere Art. 6 Abs. 1 lit. a, b, c und f
            DSGVO sowie bei Gesundheitsdaten Art. 9 Abs. 2 lit. a DSGVO, sofern
            eine ausdrückliche Einwilligung erteilt wird.
          </p>

          <h2>3. Hosting, technische Bereitstellung und Server-Logs</h2>
          <p>
            Die React-Website wird nach dem vorhandenen Deployment als Render
            Web-Service in der Region Frankfurt betrieben. Das Backend wird über
            einen gemeinsamen MediConsult/Tawan-Spa-API-Service angebunden. Beim
            Aufruf der Website und API können technisch notwendige Protokolldaten
            verarbeitet werden, insbesondere IP-Adresse, Datum und Uhrzeit,
            angeforderte URL, Referrer, Browser-/Geräteinformationen,
            Betriebssystem, HTTP-Status und übertragene Datenmenge.
          </p>
          <p>
            Zweck ist die sichere Auslieferung der Website, Fehleranalyse,
            Missbrauchsvermeidung und technische Administration. Rechtsgrundlage
            ist Art. 6 Abs. 1 lit. f DSGVO. Logdaten werden grundsätzlich nur so
            lange gespeichert, wie dies für Sicherheit, Fehleranalyse und
            Nachweiszwecke erforderlich ist.
            <span>
              {" "}
            </span>
          </p>

          <h2>4. Kundenkonto, Registrierung und Login</h2>
          <p>
            Für Registrierung, Login und Kontoverwaltung verarbeiten wir Name,
            E-Mail-Adresse, optional Telefonnummer, Passwort-Hash,
            E-Mail-Verifizierungs- und Passwort-Reset-Token,
            Kontolöschungs-Token, bevorzugte Sprache, Registrierungsquelle,
            Registrierungspfad, Test-/Produktionsumgebung sowie Zeitstempel.
          </p>
          <p>
            Die Verarbeitung dient der Vertragserfüllung und Kontosicherheit
            (Art. 6 Abs. 1 lit. b DSGVO), der Missbrauchsvermeidung und
            IT-Sicherheit (Art. 6 Abs. 1 lit. f DSGVO) sowie der Erfüllung
            gesetzlicher Pflichten, soweit einschlägig (Art. 6 Abs. 1 lit. c
            DSGVO).
          </p>

          <h2 id="buchung">5. Buchungen und Terminverwaltung</h2>
          <p>
            Bei Buchungen verarbeiten wir Kontaktdaten, Buchungsdaten,
            Terminzeit, Leistung, Dauer, Personenanzahl, Preis- und
            Steuerbestandteile, Zahlungsart und Zahlungsstatus, Standort,
            Studio-/Hotel-/Vor-Ort-Adresse, Hinweise zum Ablauf, Gutschein-,
            Kampagnen- und Empfehlungsguthabeninformationen, Storno- und
            Statusdaten sowie technische Nachweise zur Terminbestätigung.
          </p>
          <p>
            Bei Vor-Ort-Buchungen wird die Adresse zur Prüfung des Einsatzgebiets
            verarbeitet; dabei können normalisierte/geocodierte Adressdaten und
            Koordinaten entstehen. Bei Hotelbuchungen können Zimmer- oder
            Stockwerksangaben verarbeitet werden. Rechtsgrundlage ist Art. 6
            Abs. 1 lit. b DSGVO; für Sicherheits-, Missbrauchs- und
            Nachweiszwecke zusätzlich Art. 6 Abs. 1 lit. f DSGVO.
          </p>

          <h2>6. Gesundheitsdaten und sensible Hinweise</h2>
          <p>
            Dr. Hoffmann-Leistungen sind Wellnessdienstleistungen. Wenn Sie uns
            freiwillig gesundheitsbezogene Hinweise mitteilen, etwa zu
            Beschwerden, Schwangerschaft, Verletzungen, Einschränkungen,
            Implantaten oder Kontraindikationen, verarbeiten wir diese nur zur
            sicheren Vorbereitung und Durchführung oder Ablehnung der gebuchten
            Leistung. Rechtsgrundlage ist Ihre ausdrückliche Einwilligung nach
            Art. 9 Abs. 2 lit. a DSGVO in Verbindung mit Art. 6 Abs. 1 lit. a
            DSGVO. Sie können die Einwilligung jederzeit mit Wirkung für die
            Zukunft widerrufen.
          </p>
          <p>
            Bitte tragen Sie Gesundheitsdaten nur ein, wenn dies für die
            Durchführung relevant ist und Sie die gesonderte Einwilligung im
            Buchungsprozess erteilen.
          </p>

          <h2 id="zahlungen">7. Zahlungen und Stripe</h2>
          <p>
            Online-Zahlungen und Guthaben-Aufladungen werden über Stripe
            abgewickelt. Wir übermitteln oder erhalten dabei insbesondere
            Buchungs-ID, Betrag, Währung, Leistungsbeschreibung, Kundendaten,
            Stripe-Checkout-Session, Payment-Intent- und Rechnungs-ID sowie den
            Zahlungsstatus. Zahlungsinstrumentdaten wie vollständige
            Kartennummern werden nicht durch uns gespeichert.
          </p>
          <p>
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO für die
            Zahlungsabwicklung sowie Art. 6 Abs. 1 lit. c DSGVO für steuer- und
            handelsrechtliche Nachweise. Stripe kann Daten auch außerhalb der EU
            verarbeiten; hierfür sind geeignete Garantien, insbesondere
            Standardvertragsklauseln, erforderlich.
            <span>
              {" "}
            </span>
          </p>

          <h2>8. E-Mail-Versand, Erinnerungen und Brevo/SMTP</h2>
          <p>
            Bestätigungen, Erinnerungen, Passwort-Resets,
            E-Mail-Verifizierungen, Kontolöschungsnachweise, Zahlungslinks und
            interne Buchungsbenachrichtigungen werden per E-Mail versendet. Nach
            vorhandenem Text- und Codebestand ist Brevo/Sendinblue als
            Versanddienstleister vorgesehen; technisch können SMTP-Zugangsdaten
            konfiguriert sein.
          </p>
          <p>
            Verarbeitet werden insbesondere E-Mail-Adresse, Name, Termin- und
            Leistungsdaten, Spracheinstellung, Statusinformationen, ICS-Anhänge
            und technische Versanddaten. Rechtsgrundlage ist Art. 6 Abs. 1
            lit. b DSGVO, für Sicherheits- und Nachweiszwecke Art. 6 Abs. 1
            lit. f DSGVO.
            <span>
              {" "}
            </span>
          </p>

          <h2>9. Datenbank und Empfänger</h2>
          <p>
            Konto-, Buchungs- und Verwaltungsdaten werden über MongoDB/Mongoose
            in einer MongoDB-Atlas-Datenbank gespeichert. Zugriff erhalten nur
            berechtigte Personen und Systeme, insbesondere Administration,
            zuständige Mitarbeitende, technische Dienstleister, Zahlungs- und
            E-Mail-Dienstleister sowie gegebenenfalls Steuerberatung,
            Rechtsberatung oder Behörden, soweit erforderlich.
          </p>
          <p>
            Rechtsgrundlagen sind Art. 6 Abs. 1 lit. b, c und f DSGVO.
            <span>
              {" "}
            </span>
          </p>

          <h2 id="cookies">10. Cookies, Local Storage und Tracking</h2>
          <p>
            Die Website nutzt technisch erforderliche Speichertechniken, etwa
            Session Storage für Buchungs- und Registrierungsentwürfe,
            Statushinweise und Popups, Local Storage für Spracheinstellungen
            sowie First-Party-Cookies für Referrer-, Kampagnen- und
            Empfehlungszuordnung. Diese Speicherung dient der Funktionsfähigkeit
            der Buchungsstrecke und der Zuordnung berechtigter Guthaben- oder
            Aktionsansprüche. Rechtsgrundlage ist § 25 Abs. 2 TDDDG und Art. 6
            Abs. 1 lit. b bzw. f DSGVO.
          </p>
          <p>
            Die Website lädt Google Analytics/Google Tag über
            googletagmanager.com und sendet Seitenaufrufe über gtag erst nach
            Ihrer aktiven Zustimmung in der Cookie-Abfrage. Dafür können Cookies
            oder vergleichbare Kennungen gesetzt und Nutzungsdaten an Google
            übermittelt werden. Die Ablehnung ist genauso einfach möglich und hat
            keine Auswirkung auf die Nutzbarkeit der Website. Rechtsgrundlage ist
            Ihre Einwilligung nach § 25 Abs. 1 TDDDG und Art. 6 Abs. 1 lit. a
            DSGVO.
            <span>
              {" "}
            </span>
          </p>

          <h2>11. Foto, Film, Marketing und freiwillige Einwilligungen</h2>
          <p>
            Foto-, Film-, Ton-, Interview- oder Marketingdaten werden nicht über
            die AGB pauschal eingeholt. Eine Verarbeitung für Werbung,
            Social Media, Website, interne Schulung oder Kampagnen erfolgt nur,
            wenn Sie hierfür getrennt und freiwillig einwilligen. Die Ablehnung
            freiwilliger Marketing- oder Aufnahme-Einwilligungen hat keine
            Auswirkung auf die normale Buchbarkeit der angebotenen Leistungen,
            soweit kein gesondert ausgewiesenes Aktionsmodell etwas anderes
            rechtlich zulässig und transparent vorsieht.
          </p>

          <h2>12. Speicherdauer und Löschung</h2>
          <p>
            Daten werden gelöscht, sobald sie für den jeweiligen Zweck nicht mehr
            erforderlich sind und keine gesetzlichen Aufbewahrungspflichten,
            Nachweisinteressen oder Verjährungsfristen entgegenstehen. Buchungs-,
            Rechnungs- und Zahlungsdaten können wegen handels- und
            steuerrechtlicher Pflichten regelmäßig bis zu zehn Jahre aufzubewahren
            sein. Kundenkonten werden auf Antrag gelöscht, soweit keine
            Aufbewahrungspflichten entgegenstehen. Technische Entwürfe in
            Session Storage werden lokal im Browser gespeichert und können durch
            Löschen der Browserdaten entfernt werden.
          </p>
          <p>
            <span>
              {" "}
            </span>
          </p>

          <h2 id="rechte">13. Ihre Rechte</h2>
          <p>Sie haben nach Maßgabe der DSGVO insbesondere das Recht auf:</p>
          <ul>
            <li>Auskunft über die verarbeiteten personenbezogenen Daten,</li>
            <li>Berichtigung unrichtiger Daten,</li>
            <li>Löschung oder Einschränkung der Verarbeitung,</li>
            <li>Datenübertragbarkeit,</li>
            <li>Widerspruch gegen Verarbeitungen auf Grundlage berechtigter Interessen,</li>
            <li>Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft.</li>
          </ul>
          <p>
            Zur Ausübung Ihrer Rechte genügt eine Nachricht an{" "}
            <a href="mailto:info@dr-hoffmann-massage.de">
              info@dr-hoffmann-massage.de
            </a>
            .
          </p>

          <h2>14. Beschwerderecht</h2>
          <p>
            Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu
            beschweren. Für Hamburg ist dies:
          </p>
          <p>
            Der Hamburgische Beauftragte für Datenschutz und Informationsfreiheit
            (HmbBfDI), Ludwig-Erhard-Straße 22, 20459 Hamburg.
            <br />
            Website:{" "}
            <a
              href="https://datenschutz-hamburg.de"
              target="_blank"
              rel="noopener noreferrer"
            >
              datenschutz-hamburg.de
            </a>
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default DatenschutzPage;
